import { render, staticRenderFns } from "./TypographyAlignmentSection.vue?vue&type=template&id=0493dc1a"
import script from "./TypographyAlignmentSection.vue?vue&type=script&lang=ts"
export * from "./TypographyAlignmentSection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyAlignmentSection.vue?vue&type=style&index=0&id=0493dc1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports